import PropTypes from 'prop-types';

const returnReasonsShape = PropTypes.shape({
  label: PropTypes.string,
  name: PropTypes.string,
  level: PropTypes.number,
  code: PropTypes.string,
  position: PropTypes.number,
  fault: PropTypes.string,
  final: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    name: PropTypes.string,
    level: PropTypes.number,
    code: PropTypes.string,
    position: PropTypes.number,
    fault: PropTypes.string,
    final: PropTypes.bool,
    children: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      name: PropTypes.string,
      level: PropTypes.number,
      code: PropTypes.string,
      position: PropTypes.number,
      fault: PropTypes.string,
      final: PropTypes.bool,
      children: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string,
        name: PropTypes.string,
        level: PropTypes.number,
        code: PropTypes.string,
        position: PropTypes.number,
        fault: PropTypes.string,
        final: PropTypes.bool,
        children: PropTypes.arrayOf(PropTypes.shape({
          label: PropTypes.string,
          name: PropTypes.string,
          level: PropTypes.number,
          code: PropTypes.string,
          position: PropTypes.number,
          fault: PropTypes.string,
          final: PropTypes.bool,
        })),
      })),
    })),
  })),
});

export default returnReasonsShape;
